import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import Layout from "../../../component/Layout/Layout";
import Card from "../../../component/Layout/theme/card";
import { Input } from "../../../component/form/input";
import LogOut from "../../../component/dashboard/user/logout/logout";
import PageChange from "../../../component/pageChange";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";


function PayAccountPage() {
    var { t } = useTranslation()
    const { login, token, user } = useSelector((item) => item.user)
    const search = useLocation().search;
    const price = new URLSearchParams(search).get("price") ?? 0;
    const [isDataLoad, setIsDataLoad] = useState(true);
    const [currentPlanData, setCurrentPlanData] = useState({})
    const [plansData, setPlansData] = useState([])
    const [checkedPriod, setCheckedPriod] = useState("YEARLY");


    useEffect(() => {
        document.title = "پرداخت صورت حساب دوره"
        if (!login) {
            window.location.href = '/auth'
        } else {
            // getPlansData()
        }
    }, [])


    const handleCalPrice = (e) => {
        var tempPrice = price - user.payments.balance;
        return tempPrice <= 0 ? 0 : tempPrice;
    };

    const handleCalPriceWithTax = (e) => {
        var tempPrice = (price - user.payments.balance) + ((handleCalPrice() / 100) * 10);
        return tempPrice <= 0 ? 0 : tempPrice;
    };

    const formatPrice = (value) => {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };


    console.log(price);
    return (
        <>
            <Layout />
            <Card>
                {isDataLoad ? (
                    <div className="p-5 mb-24 bg-white rounded-lg shadow-md">
                        <h1 className="font-extrabold text-2xl text-start text-black mt-5">پرداخت هزینه اشتراک «فضای کاری من»</h1>
                        <h4 className="font-normal text-lg text-start text-gray-500 mt-2">در اینجا می توانید هزینه اشتراک خود را پرداخت کنید.</h4>

                        <h4 className="font-normal text-lg text-start text-gray-500 mt-8">اگر کارت هدیه دارید اینجا وارد کنید</h4>
                        <div className="flex">
                            <div className="relative mt-4 w-[300px]">
                                <Input
                                    placeholder={"کد کارت هدیه را اینجا وارد کنید"}
                                    type="text"
                                    id={"gift"}
                                    name={"gift"}
                                    autoComplete={"off"}
                                    requiredir={true}
                                    onChange={(e) => {
                                        // setPhone(e.target.value);
                                    }}
                                />
                                <div className="absolute -mt-10 -left-4">
                                    <button
                                        className="px-5 h-9 text-white bg-blue-500 rounded-lg "
                                        type="submit"
                                    // onClick={() => receiveSMS(phoneSms)}
                                    >
                                        ثبت
                                    </button>
                                </div>
                            </div>
                        </div>


                        <hr className="my-10" />

                        <div className="block p-2 px-2 text-base text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">
                            <div className="inline-flex items-start justify-start text-start w-full gap-2">
                                <p className="font-normal">اعتبار کیف پول شما: </p>
                                <p className="font-bold"> {formatPrice(user.payments.balance.toString())} تومان </p>
                            </div>
                        </div>

                        <p className="px-2 py-1 text-md">مبلغ فاکتور شما : {formatPrice(price.toString())} تومان</p>

                        <p className="px-2 py-1 text-md">مبلغ تخفیف کارت هدیه : 0 تومان</p>

                        <p className="px-2 py-1 text-md">جمع مبلغ : {formatPrice((handleCalPrice().toString()))} تومان</p>

                        <p className="px-2 py-1 text-md">مالیات ارزش افزوده : {formatPrice((((handleCalPrice() / 100) * 10)).toString())} تومان</p>

                        <p className="px-2 py-1 text-md font-bold text-red-800">مجموع مبلغ پرداختی : {formatPrice((handleCalPriceWithTax()).toString())} تومان</p>



                        <div className="flex py-4">
                            <button
                                className="px-5 h-9 text-white bg-green-600 rounded-lg "
                                type="submit"
                                onClick={() => {
                                    if (price.length > 0) {
                                        const cleanedPrice = handleCalPriceWithTax().toString().replace(/,/g, '');
                                        if (cleanedPrice < 50000) {
                                            toast.error("حداقل مبلغ پرداخت دوره ۵۰۰،۰۰۰ تومان می باشد")
                                        } else {
                                            const url = `${process.env.REACT_APP_SERVER}/api/billing/pay/period/${user._id}/${cleanedPrice}/${price}/${((handleCalPrice() / 100) * 10).toString()}/${"discountCodeData"}`;
                                            window.location.href = url;
                                        }
                                    } else {
                                        toast.error("لطفا مبلغ را وارد کنید")
                                    }
                                }}
                            >
                                صدور صورتحساب
                            </button>
                        </div>

                    </div>
                ) : (
                    <PageChange />
                )}
            </Card>
        </>
    )
}

export default PayAccountPage